import { encrypt, decrypt } from "../utils/encrypt";
import * as globalCfg from '@app/configs/global';

const language_key = 'lang';
export const getLanguage = (_default=globalCfg.language.extended) =>{
    // console.log('localStorage.getItem(language_key) || _default ======>', localStorage.getItem(language_key) || _default)
    return localStorage.getItem(language_key) || _default;
}
export const setLanguage = (lang) =>{
    return localStorage.setItem(language_key, lang);
}

const version_key = 'version';
export const getVersion = (_default) =>{
    // console.log('localStorage.getItem(language_key) || _default ======>', localStorage.getItem(language_key) || _default)
    return localStorage.getItem(version_key) || _default;
}
export const setVersion = (version) =>{
    return localStorage.setItem(version_key, version);
}

const ACCOUNT_DATA = 'account_data';
export const getAccountData = async ()     => getStorage(ACCOUNT_DATA);
export const setAccountData = async (data) => setStorage(ACCOUNT_DATA, data)

export const getLoginDataFromStorage = (storageData) => {
    const account_name    = storageData.account_name;
    const password        = storageData.password;
    const profile         = storageData.profile;

    const _loginData = { account_name: account_name, password: password, profile:profile};
    return _loginData;
}

export const getRawLoginData = () => {
  console.log('STORAGE DATA ACCOUNT: trying to get login data');
  return localStorage.getItem(ACCOUNT_DATA);
  // if(!data)
  //   return null;
  // const jsonData = JSON.parse(data);
  // console.log('STORAGE DATA ACCOUNT: ', jsonData);
  // return jsonData;
}

/**
 *
 * @param {String} area
 */
export function getStorage (area, secret='insecure') {
    return new Promise(async(res, rej) =>   {
        try {
            let rawData = localStorage.getItem(area);
            // console.log(' >> localStorage.js << :: getStorage => ', ' | area:', area, ' | rawData:', rawData);
            if(rawData===null)
            {
                // rej({error:'no_item'});
                res({error:'no_item'});
                return;
            }
            if(secret) {
                rawData = await decrypt(rawData, secret)
            }
            const data = JSON.parse(rawData);
            res({data});
        }
        catch (error) {
            console.error('Read localStorage', error)
            res({error})
        }
    })
}

/**
 *  @param {String} area
 *  @param {Object} data
 */
export function setStorage (area, data, secret='insecure') {
    return new Promise(async(res, rej)=>{
        try {
            let rawData = JSON.stringify(data)
            if (secret) {
                rawData = await encrypt(data, secret)
            }
            localStorage.setItem(area, rawData)
            res({status: 'ok'})
        } catch (error) {
            rej(error);
        }
    })
}

/**
 *  @param {String} area
 */
export function deleteStorage (area) {
    return new Promise((res, rej)=>{
            localStorage.removeItem(area)
            res({status: 'ok'})
    })
}

export function clearStorage () {
    return new Promise((res, rej)=>{
            localStorage.clear()
            res({status: 'ok'})
    })
}